<template>
	<div class="signingList-box">
		<topNav />
		<!-- 侧边栏 -->
		<div class="sidebar-btn" @click="sidebar()"></div>
		<div class="sidebar">
			<router-link :to="`/sign/${su_number}`">在线签约</router-link>
			<router-link :to="`/signingList/${su_number}`" class="sidebar-on">我的签约(下载就业协议)</router-link>
		</div>

		<h3 class="my-h3">我的签约（下载就业协议）</h3>

		<!-- 搜索 -->
		<div class="search w1200">
			<button @click="getList(true)">搜索</button>
			<input type="text" placeholder="请输入名字" v-model="search.name">
			<input type="text" placeholder="请输入高校名称" v-model="search.college_name">
			<select name="sex" v-model="search.gender">
				<option value="" hidden>选择性别</option>
				<option value="">不限</option>
				<option value="01">男</option>
				<option value="02">女</option>
			</select>
			<select name="state" v-model="search.college_sign_state">
				<option value="" hidden>高校审核状态</option>
				<!-- <option value="0">创建</option>
				<option value="1">审核中</option>
				<option value="2">已通过</option>
				<option value="3">已解约</option>
				<option value="4">已拒绝</option> -->
				<option value="">不限</option>
				<option value="0">-</option>
				<option value="1">已同意</option>
				<option value="2">已拒绝</option>
			</select>
		</div>

		<!-- 下载 -->
		<div class="w1200">
			<button class="download-all" @click="getDownload()">批量下载</button>
		</div>

		<!-- 表格 -->
		<table border="0" class="my-table w1200">
			<tr>
				<th @click="clickAll()">全选</th>
				<th>姓名</th>
				<th>性别</th>
				<th>所属高校</th>
				<th>企业签约状态</th>
				<th>学生签约状态</th>
				<th>高校审核状态</th>
				<th>协议书状态</th>
				<th>下载就业协议</th>
				<th>操作</th>
			</tr>
			<tr v-for="item in List" :key="item.code">
				<td>
					<div class="select" v-if="item.request_state && item.request_state.agreement_state != 3 "></div>
					<div class="select" :class="{'select-on':recordids.indexOf(item.recordid) != -1}" @click="add_su_numbers(item.recordid)"
					 v-else></div>
				</td>
				<td>{{item.name}}</td>
				<td v-if="item.gender == '01'">男</td>
				<td v-else-if="item.gender == '02'">女</td>
				<td v-else>-</td>
				<td>{{item.college_name}}</td>
				<td>{{department_sign_state[item.department_sign_state]}}<i v-if="item.department_sign_state == '2'" class="el-icon-warning-outline" :title="item.request_state.remark"></i></td>
				<td>{{department_sign_state[item.talent_sign_state]}}<i v-if="item.talent_sign_state == '2'" class="el-icon-warning-outline" :title="item.request_state.remark"></i></td>
				<td>{{item.request_state && (item.request_state.stateby == 'faculty' ||item.request_state.stateby == 'college')? department_sign_state[item.college_sign_state]:'-'}} <i v-if="item.college_sign_state == '2' && (item.request_state.stateby == 'faculty' ||item.request_state.stateby == 'college')" class="el-icon-warning-outline" :title="item.college_remark"></i></td>
				<td >
					<span v-if="item.request_state && item.request_state.agreement_state != 7">
						{{request_state[item.request_state.agreement_state]}}							
					</span>	
					<span class="returnStyle" v-if="item.request_state && item.request_state.agreement_state == 7">
						<router-link :to="`/sign/${item.su_number}`">高校退回待企业修改</router-link>
					</span>	
				</td>
				<td v-if="item.college_sign_state !=1 " :title="item.college_remark">-</td>
				<td v-else>
					<div @click="getDownload(item.recordid)">下载</div>
				</td>
				<td>
					<div @click="viewDetails(item)">详情</div>
				</td>
			</tr>
		</table>

		<!-- 分页 -->
		<ul class="my-paging clearfix w1200">
			<li @click="upList()">上一页</li>
			<!-- search.offset 当前页数  max 最大页数 -->
			<li v-if="search.offset>2" @click="clickNum(0)">1</li>
			<li v-if="search.offset>2" class="my-paging-ellipsis">· · ·</li>

			<li v-for="(item,i) in max" @click="clickNum(i)" :key="item.code" :class="{'my-paging-on':search.offset == i}"
			 v-show="i<3&&search.offset<3 || search.offset-2<i&&i<search.offset+2 || i>max-4&&search.offset>max-3">{{i+1}}</li>

			<li v-if="max>3&&search.offset +3<max" class="my-paging-ellipsis">· · ·</li>
			<li v-if="max>3&&search.offset +2<max" @click="clickNum(max-1)">{{max}}</li>
			<li @click="downList()">下一页</li>
		</ul>

		<Footer />
	</div>
</template>

<script>
	import topNav from '../layout/top'
	import Footer from '../layout/footer'
	import {
		getList,
		getDownload
	} from '@/api/signingList'

	export default {
		components: {
			topNav,
			Footer
		},
		data() {
			return {
				List: [{
					name: '',
					gender: '',
					college_name: '',
					department_sign_state: '',
					talent_sign_state: '',
					college_sign_state: ''
				}],
				count: 0,
				max: 0,
				department_sign_state: ['-', '已同意', '已拒绝'],
				college_sign_state: ['创建', '签约中', '审核中', '已通过', '已解约', '已拒绝'],
				request_state:['已创建','签约中','审核中','已完成','已解约','被拒绝','退回给学生','退回给企业'],
				search: {
					name: '',
					college_name: '',
					gender: '',
					college_sign_state: '',
					offset: 0,
					limit:10
				},
				su_number: null,
				recordids: [],
				allFlag: false,
				sidebarFlag: 1
			}
		},
		created() {
			if (this.$route.params.id) {
				this.su_number = this.$route.params.id
			}
			if (!localStorage.getItem('tokenInfo')) {
			if (this.su_number) {
				this.$router.push('/login/' + this.su_number)
			} else {
				this.$router.push('/login')
			}
				return
			}
			this.getList()
		},

		methods: {
			async getList(s) {
				var search = Object.assign({}, this.search);
				if (s) {
					search.offset = 0
				} else {
					search.offset = search.offset * search.limit
				}
				const res = await getList(search)
				if (res) {
					this.List = res.list
					this.count = res.count
					this.max = Math.ceil(res.count / search.limit)
				}
			},
			getDownload(i) {
				console.log(i, this.List);
				var d_str = ''
				if (i) {
					d_str = [i]
				} else if (this.recordids.length) {
					for (var i = 0; i < this.recordids.length; i++) {
						if (i == 0) {
							d_str += this.recordids[i];
						} else {
							d_str += '_' + this.recordids[i];
						}
					}
				} else {
					return;
				}
				// const res = await getDownload(d_obj)

				console.log(d_str);

				let url = '/agreement_record/department/bulk_downloadagreement?recordids=' + d_str;

				this.$http.downloadZip(url, {
					emulateJSON: true
				}, {
					responseType: 'blob'
				}).then(function(res) {
					console.log(res);
					// let blob = new Blob([res], {
					// 	type: "application/zip"
					// });
					// let objectUrl = URL.createObjectURL(blob);
					// window.location.href = objectUrl;


					var blob = new Blob([res], {
						type: "application/octet-stream"
					});
					let url = window.URL.createObjectURL(new Blob([res]));
					let link = document.createElement('a');
					link.style.display = 'none';
					link.href = url;
					link.setAttribute('download', '就业协议书.zip');
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);

				}, function(res) {});



			},
			// 查看详情
			viewDetails(item){
				console.log(item)
				// 签约状态为(创建签约、签约退回给企业)时跳转至签约确认页面
				if(item.request_state.agreement_state == '0' || item.request_state.agreement_state == '7'){
					this.$router.push('/sign/'+ item.su_number)
				}else{
					this.$router.push('/signingDetails/'+ item.su_number)
				}
			},
			sidebar() {
				console.log(this.sidebarFlag);
				var sidebar = document.querySelector('.sidebar')
				if (this.sidebarFlag) {
					sidebar.style.display = "block"
					this.sidebarFlag = 0
				} else {
					sidebar.style.display = "none"
					this.sidebarFlag = 1
				}
			},
			add_su_numbers(n) {
				var re = this.recordids
				console.log(re);
				if (re.indexOf(n) == -1) {
					re.push(n)
				} else {
					re.splice(re.indexOf(n), 1)
				}
			},
			clickAll() {
				var re = this.recordids,
					List = this.List
				if (re.length == List.length) {
					this.allFlag = true
				}
				if (this.allFlag) {
					re.splice(0, re.length)
					this.allFlag = false
				} else {
					for (var i = 0; i < List.length; i++) {
						if (List[i].request_state.agreement_state == 3) {
							re.push(List[i].recordid)
						}
					}
					this.allFlag = true
				}
			},
			upList() {
				if (this.search.offset > 0) {
					this.search.offset--
					this.getList()

					this.allFlag = false
				}
			},
			downList() {
				if (this.search.offset < this.max - 1) {
					this.search.offset++
					this.getList()

					this.allFlag = false
				}
			},
			clickNum(num) {
				if(num == this.search.offset){
					return ;
				}
				this.search.offset = num
				this.getList()
			},

		},
	}
</script>


<style scoped>
	.c-FF5555 {
		color: #FF5555;
	}

	/* 搜索 */
	.search input:nth-of-type(1),
	.search select:nth-of-type(1) {
		width: 6.25rem;
	}

	.search input:nth-of-type(2),
	.search select:nth-of-type(2) {
		width: 10rem;
	}

	.search input,
	.search select {
		box-sizing: border-box;
		padding-left: 0.9375rem;
		margin-right: 1.25rem;
		height: 1.875rem;
		vertical-align: middle;
		font-size: 0.75rem;
		color: #999;
		border: 0.0625rem solid #ccc;
	}

	.search select {
		background: url(../../assets/image/drop-down.png) no-repeat right 0.625rem center #fff;
		appearance: none;
		-moz-appearance: none;
		-webkit-appearance: none;

	}

	.search button {
		float: right;
		cursor: pointer;
		padding: 0.4375rem 2.1rem 0.4375rem 1.0625rem;
		font-size: 0.75rem;
		color: #fff;
		background: url(../../assets/image/search.png)no-repeat right 0.75rem center #5E4FFF;

	}

	@media (max-width:46.875rem) {
		.signingList-box {
			padding: 0 0.625rem;
		}

		.search input {
			margin-bottom: .3rem;
		}

		.search button {
			margin-top: 2.2rem;
			padding: 0.4375rem 0.9rem;
			background: #5E4FFF;
		}
	}

	/* 下载 */
	.download-all {
		cursor: pointer;
		margin: 2.875rem 0 1.25rem;
		padding: 0.3125rem 0.625rem 0.3125rem 1.75rem;
		border: none;
		color: #fff;
		background: url(../../assets/image/download-on.png) no-repeat 0.5625rem center #5E4FFF;
	}

	@media (max-width:46.875rem) {
		.download-all {
			margin: 2rem 0 1rem;
		}
	}

	/* 表格 */
	.my-table {
		color: #333;
		border: 0.0625rem solid #EDEDED;
	}

	.my-table th {
		font-weight: 500;
		font-size: 0.875rem;
	}

	.my-table td {
		font-weight: 300;
		font-size: 0.75rem;
	}

	.my-table td:nth-last-of-type(1) {
		cursor: pointer;
		color: #5E4FFF;
	}

	.my-table th,
	.my-table td {
		padding: 0.625rem 0;
		text-align: center;
		border: 0.0625rem solid #EDEDED;
	}

	@media (max-width:46.875rem) {

		.my-table th,
		.my-table td {
			width: 3rem;
		}

		.my-table th {
			font-size: 0.75rem;
		}
	}

	.select {
		height: 2.3125rem;
		background: url(../../assets/image/select.png) no-repeat center center;
	}

	.select-on {
		background: url(../../assets/image/select-on.png) no-repeat center center;
	}

	/* 分页 */
	.my-paging {
		margin-top: 8.125rem;
		margin-bottom: 8.125rem;
		text-align: center;
	}

	.my-paging li {
		display: inline-block;
		cursor: pointer;
		margin: 0 0.3125rem;
		padding: 0.25rem 0.6875rem;
		line-height: 1.25rem;
		border: 0.0625rem solid #ededed;
		color: #666;
	}

	.my-paging .my-paging-ellipsis {
		border: none;
		padding: 0.25rem 0;
		font-weight: 600;
	}

	.my-paging .my-paging-on {
		color: #fff;
		background: #5E4FFF;
		border: 0.0625rem solid #5E4FFF;
	}
	.returnStyle{
		color: red;
		cursor: pointer;
	}

	.returnStyle a{
		color: red;
	}
	.returnStyle:hover{
		text-decoration:underline
	}

	@media (max-width:46.875rem) {
		.my-paging {
			margin-top: 4rem;
		}

		.my-paging li {
			font-size: 0.75rem;
			margin: 0 0.1rem;
			padding: 0.25rem 0.5rem;
		}

	}
</style>
